import { getStroke } from 'perfect-freehand';

export type Point = { x: number; y: number; pressure: number };

export type Stroke = {
  id: string;
  color: string;
  size: number;
  points: Point[];
};

export type DocumentStrokes = Record<number, Stroke[]>;

const STROKE_OPTIONS = {
  thinning: 0.55,
  smoothing: 0.6,
  streamline: 0.4,
  simulatePressure: true,
  last: true,
} as const;

export function strokeToSvgPath(stroke: Stroke, width: number, height: number): string {
  if (!stroke.points.length) return '';
  const pts: number[][] = stroke.points.map((p) => [p.x * width, p.y * height, p.pressure]);
  const outline = getStroke(pts, { ...STROKE_OPTIONS, size: stroke.size });
  return outlineToPath(outline);
}

export function strokeToCanvasPath(stroke: Stroke, width: number, height: number, scale = 1): Path2D | null {
  const pts: number[][] = stroke.points.map((p) => [p.x * width, p.y * height, p.pressure]);
  const outline = getStroke(pts, { ...STROKE_OPTIONS, size: stroke.size * scale });
  if (!outline.length) return null;
  const path = new Path2D();
  path.moveTo(outline[0][0], outline[0][1]);
  for (let i = 1; i < outline.length; i++) {
    path.lineTo(outline[i][0], outline[i][1]);
  }
  path.closePath();
  return path;
}

function outlineToPath(outline: number[][]): string {
  if (!outline.length) return '';
  let d = `M ${outline[0][0].toFixed(2)} ${outline[0][1].toFixed(2)}`;
  for (let i = 1; i < outline.length; i++) {
    d += ` L ${outline[i][0].toFixed(2)} ${outline[i][1].toFixed(2)}`;
  }
  d += ' Z';
  return d;
}

export function newStrokeId(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
}
